import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/almoxarifado-cliente-aprovacao-entrada`

    return {
        list() {
            return repository.get(`${baseUrl}/list`)
        },
        edit(id) {
            return repository.get(`${baseUrl}/${id}/edit`)
        },
        approve(id) {
            return repository.put(`${baseUrl}/approve/${id}`)
        },
        reject(id) {
            return repository.put(`${baseUrl}/reject/${id}`)
        },
        datatable(queryParms = {}) {
            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
    }
}